export const initialState = {
    is_loading: true,
    notes_list: [],
    show_edit_note: false,
    ftm_note_id: null,
    ftm_id: null,
    btn_loading: false,
    ftm_note: "",
}